import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProductCouponModule } from './productcoupon.module';

platformBrowserDynamic().bootstrapModule(ProductCouponModule);
